import { createSlice } from '@reduxjs/toolkit';
import { 
  signIn, 
  logout, 
  signUp,
  editUser,
  changePass,
  deleteAccount,

  getBlogs,
  updateBlog,
  getBlog,
  getFlags,

  contact,
  // stripeAccount,
} from '../routes/UserAction';

// initialize userToken from local storage
const userToken = localStorage.getItem('userToken')
  ? localStorage.getItem('userToken')
  : null

const initialState = {
  loading: false,
  userToken,
  error: null,
  success: false,
  successMessage: '',

  searchWord: '',

  newChat: 0,
  currentType: '',
  currentId: 0,

  users: null,

  allUsers: null,

  post: null,
  page: null,

  posts: null,
  pages: null,
  
  userPage: null,
  userPost: null,
  user: null,
}

export const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
      updateProg: (state, action) => {
        let newState = { ...state };
        newState.error = null;
        newState.successMessage = '';
        newState.success = false;
        newState.loading = false;

        return newState;
      },

      updateKeyWord: (state, action) => {
        // console.log('action', action.payload);
        let newState = { ...state };
        let newWord = action.payload;
        newState.searchWord = newWord;
        return newState;
      },


      setNewChatcount: (state, action) => {
        // console.log(action.payload);
        let newState = { ...state };
        let newValue = action.payload;
        newState.newChat = newValue;

        return newState;
      },
      setCurrentType: (state, action) => {
        // console.log(action.payload);
        let newState = { ...state };
        let newValue = action.payload;
        newState.currentType = newValue;

        return newState;
      },
      setCurrentId: (state, action) => {
        // console.log(action.payload);
        let newState = { ...state };
        let newValue = action.payload;
        newState.currentId = newValue;

        return newState;
      },

      
    },


    extraReducers: (builder) => {
      builder
        // editUser
        .addCase(editUser.pending, (state) => {
          state.error = null;
          state.successMessage = '';
          state.success = false;
          state.loading = true;
        })
        .addCase(editUser.fulfilled, (state, { payload }) => {
          state.user = payload.user;
          state.success = true;
          state.loading = false;
          state.userToken = payload.token;
          state.successMessage = 'Updated successfully!';
        })
        .addCase(editUser.rejected, (state, { payload }) => {
          state.error = payload;
          state.successMessage = '';
          state.success = false;
          state.loading = false;
        })

        // changePass
        .addCase(changePass.pending, (state) => {
          state.error = null;
          state.successMessage = '';
          state.success = false;
          state.loading = true;
        })
        .addCase(changePass.fulfilled, (state, { payload }) => {
          state.user = payload.user;
          state.success = true;
          state.loading = false;
          state.userToken = payload.token;
          state.successMessage = 'Updated successfully!';
        })
        .addCase(changePass.rejected, (state, { payload }) => {
          state.error = payload;
          state.successMessage = '';
          state.success = false;
          state.loading = false;
        })
    
    
        // signIn
        .addCase(signIn.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(signIn.fulfilled, (state, { payload }) => {
          state.user = payload.user;
          state.success = true;
          state.loading = false;
          state.userToken = payload.token;
        })
        .addCase(signIn.rejected, (state, { payload }) => {
          state.loading = false;
          state.error = payload;
        })
    
        // signUp
        .addCase(signUp.pending, (state) => {
          state.error = null;
          state.successMessage = '';
          state.success = false;
          state.loading = true;
        })
        .addCase(signUp.fulfilled, (state) => {
          state.success = true;
          state.loading = false;
          state.successMessage = 'Registered successfully!';
        })
        .addCase(signUp.rejected, (state, { payload }) => {
          state.error = payload;
          state.successMessage = '';
          state.success = false;
          state.loading = false;
        })
    
        // contact
        .addCase(contact.pending, (state) => {
          state.error = null;
          state.successMessage = '';
          state.success = false;
          state.loading = true;
        })
        .addCase(contact.fulfilled, (state) => {
          state.success = true;
          state.loading = false;
          state.successMessage = 'Sent successfully!';
        })
        .addCase(contact.rejected, (state, { payload }) => {
          state.error = payload;
          state.successMessage = '';
          state.success = false;
          state.loading = false;
        })
    
        // logout
        .addCase(logout.pending, (state) => {
          state.loading = true;
        })
        .addCase(logout.fulfilled, (state) => {
          state.loading = false;
          state.user = null;
          state.userToken = null;
          localStorage.clear();
        })
        .addCase(logout.rejected, (state) => {
          state.loading = false;
          state.user = null;
          state.userToken = null;
          localStorage.clear();
        })

        // deleteAccount
        .addCase(deleteAccount.pending, (state) => {
          state.loading = true;
        })
        .addCase(deleteAccount.fulfilled, (state) => {
          localStorage.clear();
          Object.assign(state, {
            loading: false,
            user: null,
            userToken: null,
          });
        })
        .addCase(deleteAccount.rejected, (state) => {
          state.loading = false;
          localStorage.clear();
        })
        
        // getFlags
        .addCase(getFlags.pending, (state) => {
          state.loading = true;
        })
        .addCase(getFlags.fulfilled, (state, { payload }) => {
          state.flags = payload.flags;
          state.loading = false;
        })
        .addCase(getFlags.rejected, (state) => {
          state.loading = false;
        })
        
        // getBlogs
        .addCase(getBlogs.pending, (state) => {
          state.loading = true;
        })
        .addCase(getBlogs.fulfilled, (state, { payload }) => {
          state.blogs = payload.blogs;
          state.loading = false;
        })
        .addCase(getBlogs.rejected, (state) => {
          state.loading = false;
        })
        
        // getBlog
        .addCase(getBlog.pending, (state) => {
          state.loading = true;
        })
        .addCase(getBlog.fulfilled, (state, { payload }) => {
          state.blog = payload.blog;
          state.loading = false;
        })
        .addCase(getBlog.rejected, (state) => {
          state.loading = false;
        })
        
        // updateBlog
        .addCase(updateBlog.pending, (state) => {
          state.loading = true;
        })
        .addCase(updateBlog.fulfilled, (state, { payload }) => {
          state.blog = payload.blog;
          state.loading = false;
        })
        .addCase(updateBlog.rejected, (state) => {
          state.loading = false;
        });
    }

    
  })

// Action creators are generated for each case reducer function
export const { updateKeyWord, updateProg, setNewChatcount, setCurrentId, setCurrentType } = userSlice.actions

export default userSlice.reducer